import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadModelViewer } from "../utils/loadModelViewer";
import SeoHelmet from "../components/SeoHelmet";

import HeroStatementSection from "../components/HeroStatementSection";
import ServiceHero from "../components/ServiceHero";
import TechStackHero from "../components/TechStackHero";

import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";


function Hero({
  serviceIsOpen,
  onServiceToggle,
  techIsOpen,
  onTechToggle,
  serviceHeaderRef,
  techHeaderRef,
  className = "",
}) {
  const navigate = useNavigate();

  useEffect(() => {
    loadModelViewer();
  }, []);


  return (
    <>
      <SeoHelmet
        title="Denis Bitter — Fullstack Entwickler & Software Architekt"
        description="Ich entwickle Web-Apps, die funktionieren und bleiben. React, Angular, Flutter — für Startups und Unternehmen die verlässliche Software brauchen. Remote oder vor Ort."
        url="https://www.denisbitter.de/"
        image="https://www.denisbitter.de/images/hero-og.png"
      />

      {/* ========== AKT 1: MEIN WARUM ========== */}
  <HeroStatementSection className={className} />

      {/* ========== 2. SOFTWARE DIE FUNKTIONIERT ========== */}
      <ServiceHero isOpen={serviceIsOpen} onToggle={onServiceToggle} headerRef={serviceHeaderRef} />

         {/* ========== 3. TECH STACK + VERTRAUEN ========== */}
      
      
      {/* ========== 3. TECH STACK + VERTRAUEN ========== */}
      <TechStackHero
        isOpen={techIsOpen}
        onToggle={onTechToggle}
        headerRef={techHeaderRef}
        onCompanyClick={() => {
          navigate("/about#referenzen");
          setTimeout(() => window.scrollTo({ top: 0, behavior: "instant" }), 0);
        }}
      />

   
    </>
  );

}

export default Hero;
